import AnalyticalSplitAnalyticalFieldHeaderCurrentIllustration from './assets/headerLevel/analytical-split-analytical-field-current.png';
import AnalyticalSplitAnalyticalFieldHeaderCurrentRecommended from './assets/headerLevel/analytical-split-analytical-field-recommended.png';
import AnalyticalSplitCostCentreHeaderCurrentIllustration from './assets/headerLevel/analytical-split-cost-centre-current.png';
import AnalyticalSplitCostCentreHeaderCurrentRecommended from './assets/headerLevel/analytical-split-cost-centre-recommended.png';
import AnalyticalSplitAnalyticalFieldHeaderLineCurrentIllustration from './assets/headerLineLevel/analytical-split-analytical-field-current.png';
import AnalyticalSplitAnalyticalFieldHeaderLineCurrentRecommended from './assets/headerLineLevel/analytical-split-analytical-field-recommended.png';
import AnalyticalSplitCostCentreHeaderLineCurrentIllustration from './assets/headerLineLevel/analytical-split-cost-centre-current.png';
import AnalyticalSplitCostCentreHeaderLineCurrentRecommended from './assets/headerLineLevel/analytical-split-cost-centre-recommended.png';

export const CompareExportIllustration = ({
  selectedTab,
  exportLevel,
  fieldType,
}: {
  selectedTab: 'current' | 'recommended';
  exportLevel: 'header' | 'headerLine';
  fieldType: 'customField' | 'costCenter' | 'expenseCategory';
}) => {
  const images = {
    header: {
      current: {
        costCenter: AnalyticalSplitCostCentreHeaderCurrentIllustration,
        customField: AnalyticalSplitAnalyticalFieldHeaderCurrentIllustration,
        expenseCategory:
          AnalyticalSplitAnalyticalFieldHeaderCurrentIllustration,
      },
      recommended: {
        costCenter: AnalyticalSplitCostCentreHeaderCurrentRecommended,
        customField: AnalyticalSplitAnalyticalFieldHeaderCurrentRecommended,
        expenseCategory: AnalyticalSplitAnalyticalFieldHeaderCurrentRecommended,
      },
    },
    headerLine: {
      current: {
        costCenter: AnalyticalSplitCostCentreHeaderLineCurrentIllustration,
        customField:
          AnalyticalSplitAnalyticalFieldHeaderLineCurrentIllustration,
        expenseCategory:
          AnalyticalSplitAnalyticalFieldHeaderLineCurrentIllustration,
      },
      recommended: {
        costCenter: AnalyticalSplitCostCentreHeaderLineCurrentRecommended,
        customField: AnalyticalSplitAnalyticalFieldHeaderLineCurrentRecommended,
        expenseCategory:
          AnalyticalSplitAnalyticalFieldHeaderLineCurrentRecommended,
      },
    },
  } as const;

  const source = images[exportLevel][selectedTab][fieldType];

  const alt =
    selectedTab === 'current'
      ? 'Current export illustration'
      : 'Recommended export illustration';

  return (
    <div className="flex h-full w-full items-center justify-center bg-gray-50">
      <img src={source} alt={alt} className="w-[592px] object-contain" />
    </div>
  );
};
